import React, { FunctionComponent } from "react";
import { TextField } from "@material-ui/core";
import IRecipientDetailsProps from "./Recipient";

export const StepFour: FunctionComponent<IRecipientDetailsProps.StepFourProps> = ({
  bankAccountNameCorresponding,
  setBankAccountNameCorresponding,
  bankAccountNumberCorresponding,
  setBankAccountNumberCorresponding,
  setConfirmAccNumber,
  confirmAccNumber,
}) => {
  // const [confirmAccNumber, setConfirmAccNumber] = React.useState("");
  const specialCharRegExp = "[a-zA-Z0-9 ]{1,}";

  return (
    <div className="space-y-10">
      <div id="line1" className="flex space-x-20">
        <TextField
          className="w-[400px]"
          name="username"
          placeholder="Bank Account Number"
          variant="outlined"
          required={true}
          onChange={(e) => setBankAccountNumberCorresponding(e.target.value)}
          value={bankAccountNumberCorresponding}
          inputProps={{ pattern: { specialCharRegExp } }}
        />
        <div className="flex flex-col">
          <TextField
            className="w-[400px]"
            name="username"
            placeholder="Confirm Bank Account Number"
            variant="outlined"
            required={true}
            onChange={(e) => setConfirmAccNumber(e.target.value)}
            value={confirmAccNumber}
          />
          {confirmAccNumber !== bankAccountNumberCorresponding && confirmAccNumber && (
            <span className="text-red-500 text-[12px] ml-3">The account numbers do not match.</span>
          )}
        </div>
      </div>
      <div id="line2" className="flex space-x-20">
        <TextField
          className="w-[400px]"
          name="username"
          placeholder="Bank Name"
          variant="outlined"
          required
          fullWidth
          onChange={(e) => setBankAccountNameCorresponding(e.target.value)}
          value={bankAccountNameCorresponding}
          inputProps={{ pattern: { specialCharRegExp } }}
        />
      </div>
    </div>
  );
};
